import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import TeamForm from "../components/TeamForm";
import AchievementForm from "../components/AchievementForm";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";

export default function AchievementAdd({ teamId }: { teamId: number }) {

    const saveAchievement = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/achievements`), data).then((response) => {
            router.visit(`/admin/teams`);
        }).catch((error) => {
            alert("Error adding achievement: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Add Achievement" />
            <ContentWrapper>
                <AchievementForm onSubmit={saveAchievement} teamId={teamId} />
            </ContentWrapper>
        </App >
    )
}